import ApiService from '@/services/api.service'

const baseUrl = '/api/giveModes'

const GiveModeService = {

	/**
	 * Retourne le mode pour l'id donné
	 * @param {Number} id identifiant du mode
	 */
	getGiveMode: async function(id) {
		
		const response = await ApiService.get(baseUrl + '/' + id)
		return response.data
	},

	/**
	 * Recherche les modes
	 */
	getGiveModes: async function() {

		const response = await ApiService.get(baseUrl)
		return response.data
	},

	/**
	 * Création d'un mode ou mise à jour d'un mode
	 * 
	 * @param {Object} mode 
	 */
	saveGiveMode: async function(giveMode) {

		if (giveMode.id) {
			const response = await ApiService.post(baseUrl + '/'+ giveMode.id, giveMode)
			return response.data
		} else {
			const response = await ApiService.post(baseUrl, giveMode)
			return response.data
		}
	}
}

export default GiveModeService